<nz-table
	#enrollmentTable
	[nzShowPagination]="true"
	[nzFrontPagination]="true"
	[nzPageSize]="10"
	[nzTotal]="enrollmentData().length"
	[nzData]="enrollmentData()"
	[nzBordered]="true"
	nzSize="small"
>
	<thead>
		<tr>
			<th nzWidth="40%">Student</th>
			<th nzWidth="20%">Enrolled</th>
		</tr>
	</thead>
	<tbody>
		@for (student of enrollmentTable.data; track $index) {
			@if (student.cognito_uuid) {
				<tr class="student-row">
					@if (isAdmin()) {
						<td class="user-link">
							<a
								(click)="
									nav.navigateWithMatrix$(['my', 'admin', 'iam'], {
										userPoolUuid: student.user_pool_id,
										cognitoUuid: student.cognito_uuid,
									})
								"
							>
								{{ student.cognito_uuid | displayName: 'cognito' | async }}
							</a>
						</td>
					} @else {
						<td>
							{{ student.cognito_uuid | displayName: 'cognito' | async }}
						</td>
					}
					<td>
						<label nz-checkbox [(ngModel)]="student.enrolled">Enrolled</label>
					</td>
				</tr>
			}
		}
	</tbody>
</nz-table>

<br />

<button nz-button nzType="primary" (click)="saveEnrollment()" [disabled]="loading()">
	Save Enrollment
	@if (loading()) {
		<nz-spin nzSimple nzSize="small"></nz-spin>
	}
</button>

<br />
<br />
